<mat-drawer-container [hasBackdrop]="'false'">
  <mat-drawer-content>
    <ng-container [ngSwitch]="layoutState$ | async">
      <ng-container *ngSwitchCase="Layout.MOBILE">
        <div class="three-panel-page-container-mobile">
          <div class="three-panel-page-container-mobile-header">
            <ng-content select="crm-three-panel-page-content-header"></ng-content>
          </div>
          <mat-tab-group mat-stretch-tabs="true" #mobileTab>
            <mat-tab>
              <ng-template mat-tab-label>
                <span class="tab-label-centered">{{ leftPanelTitle }}</span>
              </ng-template>
              <ng-container *ngTemplateOutlet="leftPanelContent"></ng-container>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                <span class="tab-label-centered">{{ centerPanelTitle }}</span>
              </ng-template>
              <ng-container *ngTemplateOutlet="centerPanelContent"></ng-container>
            </mat-tab>
            <mat-tab *ngIf="showRightPanel">
              <ng-template mat-tab-label>
                <span class="tab-label-centered">{{ rightPanelTitle }}</span>
              </ng-template>
              <ng-container *ngTemplateOutlet="rightPanelContent"></ng-container>
            </mat-tab>
          </mat-tab-group>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="Layout.TABLET">
        <ng-container *ngIf="showRightPanel; else tabletNoRightPanel">
          <div class="three-panel-page-container">
            <ng-container *ngTemplateOutlet="leftPanelContent"></ng-container>

            <div class="three-panel-page-tablet-tabs">
              <mat-tab-group class="three-panel-page-tablet-tabs-group">
                <mat-tab label="{{ centerPanelTitle }}">
                  <ng-container *ngTemplateOutlet="centerPanelContent"></ng-container>
                </mat-tab>
                <mat-tab label="{{ rightPanelTitle }}">
                  <ng-container *ngTemplateOutlet="rightPanelContent"></ng-container>
                </mat-tab>
              </mat-tab-group>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <div class="three-panel-page-container">
          <ng-container *ngTemplateOutlet="leftPanelContent"></ng-container>
          <ng-container *ngTemplateOutlet="centerPanelContent"></ng-container>
          <ng-container *ngIf="showRightPanel">
            <ng-container *ngTemplateOutlet="rightPanelContent"></ng-container>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>

    <ng-template #tabletNoRightPanel>
      <div class="three-panel-page-container">
        <ng-container *ngTemplateOutlet="leftPanelContent"></ng-container>
        <ng-container *ngTemplateOutlet="centerPanelContent"></ng-container>
      </div>
    </ng-template>

    <ng-template #leftPanelContent>
      <ng-content select="crm-three-panel-page-left-panel"></ng-content>
    </ng-template>

    <ng-template #centerPanelContent>
      <ng-content select="crm-three-panel-page-center-panel"></ng-content>
    </ng-template>

    <ng-template #rightPanelContent>
      <ng-content select="crm-three-panel-page-right-panel"></ng-content>
    </ng-template>
  </mat-drawer-content>
  <mat-drawer
    class="profile-page-sidenav"
    [mode]="'over'"
    position="end"
    role="region"
    [opened]="sidenavOpen$ | async"
    [ngClass]="{ 'full-screen': mobile$ | async }"
  >
    <crm-sidenav-content></crm-sidenav-content>
  </mat-drawer>
</mat-drawer-container>
